import "./MultiAccountVettingResultsComponent.scss";
import template from "./MultiAccountVettingResultsComponent.html";
import {IComponentOptions} from "angular";
import {OrderVettingResponse, VettingOutcomes} from "../../../types/OrderVettingResponse";
import {ReplaySubject} from "rxjs";

export const MultiAccountVettingResults = "tfMultiAccountVettingResults";

export function multiAccountVettingResults(): IComponentOptions {
    return {
        template,
        bindings: {
            outcomes: "<",
            responses: "<"
        },
        require: {
            form: "?^^form"
        },
        controllerAs: "ctrl",
        controller: VettingResultsComponentController
    };
}

export class VettingResultsComponentController {

    /** @input */
    public set outcomes(outcomes: VettingOutcomes[] | null) {
        if (outcomes != null) {
            this.outcomes$.next(outcomes);
        }
    }

    /** @input */
    public set responses(responses: OrderVettingResponse[] | null) {
        if (responses != null) {
            this.responses$.next(responses);
        }
    }

    private readonly outcomes$ = new ReplaySubject<VettingOutcomes[]>(1);
    private readonly responses$ = new ReplaySubject<OrderVettingResponse[]>(1);
}
